import { useQueryClient } from 'react-query';

export default ({ location }) => {
  const queryClient = useQueryClient();
  const documentId = location.pathname.split('/')[2];
  const allDocument = queryClient.getQueryData('get-document');
  const document = allDocument?.find((c) => c.id === documentId);

  return document?.filename || '';
};
